<template>
  <div class="search-terms">
    <p class="level-1">搜索关键词</p>
    <p class="level-2">关键词</p>
    <p class="tips">
      <i class="el-icon-info"></i>系统已根据商品等信息为你推荐了关键词
    </p>
    <div class="button-box">
      <div class="btn" :class="{ disabled: !haveProduct }" @click="handleAdd">
        <i class="el-icon-plus" style="font-weight: 600"></i>
        添加关键词
      </div>
      <p class="keyword-chosen-text">
        已选 <span>{{ form.keywords.length }}</span
        >/1000
      </p>
    </div>

    <div class="recommend-keywords-list">
      <el-table
        class="list"
        ref="multipleTable"
        :data="form.keywords"
        height="440px"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          prop="word"
          label="已选关键词"
          align="left"
        ></el-table-column>
        <el-table-column
          prop="matchingMode"
          label="匹配方式"
          width="120"
          align="center"
        >
          <template slot="header">
            <span>匹配方式</span>
            <el-popover placement="top-end" trigger="hover" width="400">
              <div class="tip-box">
                <div class="head-box">
                  <p class="head-text">
                    匹配方式：用户的搜索内容如何匹配到你的广告创意
                  </p>
                  <p style="margin: 12px 0">
                    以关键词“鲜花采购”为例，搜索词形式支持：
                  </p>
                </div>
                <div class="word-intro-box">
                  <div class="row-box">
                    <span class="word-box">精确</span>
                    <span class="intro-box"
                      >用户搜索内容与关键词完全相同（只允许“鲜花采购”）</span
                    >
                  </div>
                  <div class="row-box">
                    <span class="word-box">短语</span>
                    <span class="intro-box"
                      >用户搜索内容精确包含关键词（如：鲜花采购，北京鲜花采购，鲜花采购建议）</span
                    >
                  </div>
                  <div class="row-box">
                    <span class="word-box">广泛</span>
                    <span class="intro-box"
                      >用户搜索内容精确包含关键词，或与关键词语义相近（如：鲜花采购，鲜花购买，玫瑰鲜花采购，如何购买鲜花）</span
                    >
                  </div>
                </div>
              </div>
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <i
              class="el-icon-error"
              style="cursor: pointer"
              @click="handleDel(scope.row.id)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <p class="tips">
      <i class="el-icon-info"></i>建议添加至少 500 个关键词，帮助计划扩量
    </p>

    <el-drawer class="drawer" :visible.sync="show" :with-header="false">
      <div class="head">
        <p class="head-text">
          已选关键词（<span>{{ multipleSelection.length }}</span
          >/1000）
        </p>
      </div>
      <div class="main">
        <el-table
          class="list"
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          height="100%"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="word"
            label="已选关键词"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="matchingMode"
            label="匹配方式"
            width="120"
            align="center"
          >
            <template slot="header">
              <span>匹配方式</span>
              <el-popover placement="top-end" trigger="hover" width="400">
                <div class="tip-box">
                  <div class="head-box">
                    <p class="head-text">
                      匹配方式：用户的搜索内容如何匹配到你的广告创意
                    </p>
                    <p style="margin: 12px 0">
                      以关键词“鲜花采购”为例，搜索词形式支持：
                    </p>
                  </div>
                  <div class="word-intro-box">
                    <div class="row-box">
                      <span class="word-box">精确</span>
                      <span class="intro-box"
                        >用户搜索内容与关键词完全相同（只允许“鲜花采购”）</span
                      >
                    </div>
                    <div class="row-box">
                      <span class="word-box">短语</span>
                      <span class="intro-box"
                        >用户搜索内容精确包含关键词（如：鲜花采购，北京鲜花采购，鲜花采购建议）</span
                      >
                    </div>
                    <div class="row-box">
                      <span class="word-box">广泛</span>
                      <span class="intro-box"
                        >用户搜索内容精确包含关键词，或与关键词语义相近（如：鲜花采购，鲜花购买，玫瑰鲜花采购，如何购买鲜花）</span
                      >
                    </div>
                  </div>
                </div>
                <i class="el-icon-question" slot="reference"></i>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom">
        <div class="right-btns">
          <div class="btn next" @click="handleComfirm">确定</div>
          <div class="btn" @click="show = false">取消</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    haveProduct: Boolean,
    list: Array
  },
  data() {
    return {
      show: false,
      multipleSelection: [],
    };
  },
  methods: {
    handleAdd() {
      if (!this.haveProduct) return;
      this.show = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleComfirm() {
      this.form.keywords = this.multipleSelection;
      this.$message.success("添加关键词成功");
      this.show = false;
    },
    handleDel(id) {
      this.form.keywords = this.form.keywords.filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search-terms {
  width: 440px;
  .level-1 {
    margin-top: 56px;
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .tips {
    margin: 4px 0;
    line-height: 20px;
    font-size: 12px;
    color: #333;
    .el-icon-info {
      margin-right: 5px;
      font-size: 16px;
      color: #969696;
      vertical-align: -2px;
    }
  }
  .button-box {
    padding-top: 10px;
    overflow: hidden;
    .btn {
      float: left;
      padding: 5px 11px;
      width: 112px;
      text-align: center;
      color: #333;
      background-color: #fff;
      line-height: 22px;
      border-radius: 4px;
      border: solid 1px #999;
      user-select: none;
      cursor: pointer;
      &.disabled {
        opacity: .3;
        cursor: not-allowed;
        &:hover {
          background-color: #fff;
          border-color: #999;
        }
      }
      &:hover {
        background-color: #edf1fd;
        border-color: #194ce5;
      }
    }
    .keyword-chosen-text {
      float: right;
      padding-top: 5px;
      color: #999;
      span {
        margin-left: 5px;
        color: #194ce5;
      }
    }
  }

  .recommend-keywords-list {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  ::v-deep .list {
    overflow: auto;
    .is-leaf {
      font-size: 12px;
      color: #333;
      background-color: #f5f5f5;
    }
    .el-icon-question {
      margin-left: 3px;
      color: #d3d3d3;
      font-size: 16px;
      vertical-align: -1px;
    }
  }
  .drawer {
    .head {
      padding: 24px 24px 0;
      .head-text {
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        span {
          color: #194ce5;
        }
      }
    }
    .main {
      padding: 24px;
      height: calc(100vh - 50px - 66px);
    }
    .bottom {
      padding: 16px 24px;
      border-top: 1px solid #e5e5e5;
      height: 66px;
      background-color: #fff;
      overflow: hidden;
      .right-btns {
        overflow: hidden;
        .btn {
          float: right;
          min-width: 100px;
          padding: 5px 16px;
          border-radius: 4px;
          text-align: center;
          line-height: 22px;
          color: #333;
          background: #fff;
          border-color: #999;
          border: 1px solid #dcdde0;
          transition: all 0.3s ease;
          cursor: pointer;
          &:hover {
            background: #edf1fd;
            border-color: #194ce5;
          }
          &.next {
            margin-left: 8px;
            color: #fff;
            background: #194ce5;
            border: 1px solid transparent;
            &:hover {
              background: #4784ff;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.tip-box {
  padding: 5px;
  color: #666;
  font-size: 12px;
  background-color: #fff;
  border-radius: 4px;
  .head-box {
    border-bottom: 1px solid #e0e0e0;
    .head-text {
      margin: 12px 0;
      font-weight: 600;
      line-height: 18px;
    }
  }
  .word-intro-box {
    .row-box {
      margin-top: 10px;
      overflow: hidden;
      .word-box {
        float: left;
        margin-right: 40px;
        font-weight: bold;
      }
      .intro-box {
        float: left;
        width: 82%;
      }
    }
  }
}
</style>